import { FONT, PALETTE_LIGHT, mediaMinWidth, styled } from "@dexibit/styles";

import {
  MOBILE_BAR_HEIGHT,
  NAV_WIDTH_COLLAPSED,
} from "./components/Navigation/constants";

export const AppGrid = styled("div")`
  font-family: ${FONT.BODY_REGULAR.fontFamily};
  font-size: ${FONT.BODY_REGULAR.fontSize};
  color: ${PALETTE_LIGHT.TEXT_EMPHASIS_REGULAR};
  display: grid;
  height: 100dvh;
  width: 100%;
  box-sizing: border-box;
  grid-template-columns: 1fr;
  grid-template-areas: "main-content";
  grid-template-rows: 1fr;
  padding-top: ${MOBILE_BAR_HEIGHT}px;

  &.has-mega-header {
    grid-template-areas:
      "mega-header"
      "main-content";
    grid-template-rows: auto 1fr;
  }

  ${mediaMinWidth.tablet(`
    grid-template-columns: ${NAV_WIDTH_COLLAPSED}px 1fr;
    grid-template-areas: "navigation main-content";
    padding-top: 0;

    &.has-mega-header {
      grid-template-areas:
        "mega-header mega-header"
        "navigation main-content";
      grid-template-rows: auto 1fr;
    }
  `)}
`;

export const MegaHeaderArea = styled("div")`
  grid-area: mega-header;
`;

export const NavigationArea = styled("div")`
  display: contents;

  ${mediaMinWidth.tablet(`
    grid-area: navigation;
    display: block;
  `)}
`;

export const MainContentArea = styled("div")`
  grid-area: main-content;
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const AppContent = styled("section")`
  background-color: ${PALETTE_LIGHT.SURFACE_TEXTURE};
  flex: 1;
  display: flex;
`;

export const LoadingContainer = styled("div")`
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ErrorContainer = styled("div")`
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledIframe = styled("iframe")`
  width: 100%;
  height: 100%;
  border: none;
`;

export const Styled404Container = styled("div")`
  width: 100%;
  height: 100%;
  border: none;
`;
